var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.goodsOrder.proxied == true ||
      _vm.subOptionCode == "SellerRandomDeliver"
        ? _c("div", { staticClass: "simple-row" }, [
            _c(
              "div",
              { staticClass: "left" },
              [
                _vm.checkActionPerm("alloc_by_proxy") &&
                _vm.goodsOrder != null &&
                _vm.goodsOrder.manualAllocFlag &&
                !_vm.goodsOrder.cancelled
                  ? _c(
                      "el-button",
                      {
                        staticClass: "el-search-btn",
                        attrs: { type: "primary" },
                        on: {
                          click: function($event) {
                            _vm.goSwbOrderGoodsAllocItemSaveVue()
                          }
                        }
                      },
                      [_c("span", [_vm._v("代配货")])]
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.goodsAllocDtoList, function(goodsAllocDto) {
        return _vm.goodsAllocDtoList.length > 0
          ? _c(
              "div",
              { staticClass: "table-layout mb30" },
              [
                _c(
                  "p",
                  {
                    staticStyle: {
                      "line-height": "40px",
                      "background-color": "#eef1f6",
                      "font-size": "14px",
                      border: "1px solid #dfe6ec",
                      "border-bottom": "0px"
                    }
                  },
                  [
                    _c("span", { staticClass: "ml20" }, [
                      _c("b", { staticStyle: { "font-weight": "bold" } }, [
                        _vm._v("配货标题：")
                      ]),
                      _vm._v(_vm._s(goodsAllocDto.title || "无"))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "ml20" }, [
                      _c("b", { staticStyle: { "font-weight": "bold" } }, [
                        _vm._v("业务单元：")
                      ]),
                      _vm._v(_vm._s(goodsAllocDto.buyerBizUnitName))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "ml20" }, [
                      _c("b", { staticStyle: { "font-weight": "bold" } }, [
                        _vm._v("所属部门：")
                      ]),
                      _vm._v(_vm._s(goodsAllocDto.buyerShopName))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "ml20" }, [
                      _c("b", { staticStyle: { "font-weight": "bold" } }, [
                        _vm._v("联系人：")
                      ]),
                      _vm._v(
                        _vm._s(goodsAllocDto.buyerRecvContractName || "无")
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "ml20" }, [
                      _c("b", { staticStyle: { "font-weight": "bold" } }, [
                        _vm._v("联系电话：")
                      ]),
                      _vm._v(_vm._s(goodsAllocDto.buyerRecvContactTel || "无"))
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticStyle: {
                      "line-height": "40px",
                      "background-color": "#eef1f6",
                      "font-size": "14px",
                      border: "1px solid #dfe6ec",
                      "border-top": "0px"
                    }
                  },
                  [
                    _c("span", { staticClass: "ml20" }, [
                      _c("b", { staticStyle: { "font-weight": "bold" } }, [
                        _vm._v("收货地址：")
                      ]),
                      _vm._v(_vm._s(goodsAllocDto.buyerRecvAddr || "无"))
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-table",
                  {
                    staticStyle: { width: "100%" },
                    attrs: { data: goodsAllocDto.itemList, border: "" }
                  },
                  [
                    _c("el-table-column", {
                      attrs: { align: "left", prop: "title", label: "商品名称" }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "left",
                        prop: "catName",
                        label: "分类名称",
                        width: "150"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "left",
                        prop: "brandName",
                        label: "品牌名称",
                        width: "120"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "right",
                        prop: "price",
                        label: "含税价(元)",
                        width: "80"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("span", [
                                _vm._v(_vm._s(scope.row.price || 0.0))
                              ])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "right",
                        prop: "taxRate",
                        label: "税率(%)",
                        width: "80"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("span", [
                                _vm._v(_vm._s(scope.row.taxRate || 0.0))
                              ])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "right",
                        prop: "ntxPrice",
                        label: "未税价(元)",
                        width: "80"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("span", [
                                _vm._v(_vm._s(scope.row.ntxPrice || 0.0))
                              ])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "right",
                        prop: "quantity",
                        label: "配货数量",
                        width: "80"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "right",
                        prop: "shipQuantity",
                        label: "发货数量",
                        width: "100"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              scope.row.shipQuantity != null
                                ? _c("span", { staticClass: "font-green" }, [
                                    _vm._v(_vm._s(scope.row.shipQuantity))
                                  ])
                                : _c("span", { staticClass: "font-green" }, [
                                    _vm._v("0")
                                  ])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "right",
                        prop: "recvQuantity",
                        label: "收货数量",
                        width: "80"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              scope.row.recvQuantity != null
                                ? _c("span", { staticClass: "font-red" }, [
                                    _vm._v(_vm._s(scope.row.recvQuantity))
                                  ])
                                : _c("span", { staticClass: "font-red" }, [
                                    _vm._v("0")
                                  ])
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e()
      }),
      _vm._v(" "),
      _vm.goodsAllocDtoList.length <= 0 ? _c("div", [_vm._m(0)]) : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "no-data" }, [
      _c("i", {
        staticClass: "icon iconfont icon-zanwushuju mr10",
        staticStyle: { "font-size": "58px", "vertical-align": "middle" }
      }),
      _vm._v(" "),
      _c("span", {}, [_vm._v("暂无数据 . . .")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5822777e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5822777e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/order/OrderGoodsAllocItemList.vue
// module id = 1823
// module chunks = 1